import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, ToastController, PopoverController, Popover, ActionSheetController, ActionSheet, Events, LoadingController } from 'ionic-angular';
import { iConfiguracion } from '../../models/basePage';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { APIOnLine } from '../../services/api/api.services';
import { LoginPage } from '../login/login';
import { ResultadoPage } from '../resultado/resultado';
import { NgForm } from '@angular/forms/src/directives/ng_form';
import { SignatureComponent } from '../../components/signature/signature';
import { Proxy } from '../../services/proxy/proxy.service';
import { NuevoMenuDerechoComponent } from '../../components/nuevo-menu-derecho/nuevo-menu-derecho';
import { PaginaBasica } from '../../models/PaginaBase';

export interface iRenuncia {
  texto: string;
  valor: boolean;
}
export interface iClubRenuncia {
  nombre: string;
  id: number;
}

@IonicPage()
@Component({
  selector: 'page-custodia',
  templateUrl: 'custodia.html',
})
export class CustodiaPage extends PaginaBasica {

  //#region Propiedades del controlador

  public custodia: Proxy.PrActasCustodia;
  public designacion: Proxy.PrDesignaciones;
  public renuncias: Array<iRenuncia> = [
    {
      texto: 'Custodia de la tablet',
      valor: false
    },
    {
      texto: 'Renuncia a la custodia de la tablet',
      valor: true
    }
  ];
  public responsabilidades: Array<iRenuncia> = [
    {
      texto: 'Acepto declaración de responsabilidad',
      valor: true
    },
    {
      texto: 'No acepto declaración de responsabilidad',
      valor: false
    }
  ];
  public clubes: Array<iClubRenuncia> = [];
  public primerFormularioValidado: boolean = false;
  public firma: string = '';
  public bloquear: boolean = false;
  public esDelegadoCampo: boolean = false;      // Indica si es delegado de campo el que se hará cargo de la custodia
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;

  // Acceso al componente Signature
  @ViewChild(SignatureComponent)
  public signatureComponent: SignatureComponent;
  //#endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public events: Events,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public Persistentes: APIOnLine.Persistentes,
    private popOverCtrl: PopoverController,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    console.log('ionViewDidEnter CustodiaPage');
    this.designacion = this.Persistentes.GetDesignacion();

    this.participantes = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.designacion.idLocal);
    this.licencias = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.designacion.idLocal);
    this.custodia = new Proxy.PrActasCustodia(this.CFutbolActas, this.DBService2, this.Persistentes);

    this.MostrarOcultarCarga(false, "cargando custodia");

    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        return this.participantes.CargarListaParticipacion();
      })
      .then((resultado: boolean) => {
        return this.licencias.ObtenerAlineables(false, false, true);
      })
      .then((resultado: boolean) => {
        return this.custodia.CustodiaPorDesignacion(this.designacion.urlApi, this.designacion.idDesignacion);
      })
      .then((resultado: Proxy.PrActasCustodia) => {
        console.log(resultado);
        this.custodia = resultado;

        this.MostrarOcultarCarga();

        if (this.custodia.EsEstadoInicial()) {
          this.custodia.renuncia = undefined;
        }

        this.esDelegadoCampo = false;
        this.primerFormularioValidado = false;

        // Inicialización de la lista de los dos clubes
        this.clubes = [
          {
            id: this.designacion.idLocal,
            nombre: this.designacion.local
          },
          {
            id: this.designacion.idVisitante,
            nombre: this.designacion.visitante
          }
        ];

        // Se comprueba si el dispositivo ya está en custodia
        if (this.custodia.entregada || this.custodia.renuncia || !this.custodia.sinIncidencias) {
          this.Mensaje("El dispositivo ya está en CUSTODIA, ha renunciado a ella o ha anotado alguna incidencia. No se puede volver a completar este formulario.", 4000);
          this.bloquear = true;
        }
      })
      .catch(error => console.error(error));
  }

  //#region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent, {
      actual: CustodiaPage,
      primeraParte: true
    });

    popover.present({
      ev: event
    });
  }

  /**
   * Activa el segundo formulario de la custodia
   * @param form Datos del formulario
   */
  public ActivarSegundoFormulario(form: NgForm): void {
    if (form.valid) {
      this.primerFormularioValidado = true;
    }
  }

  public ActualizarResponsabilidad(dato: iRenuncia): void {
    if (dato != undefined) {
      this.custodia.aceptaResponsabilidad = dato.valor;

      this.custodia.Guardar(false)
        .then((resultado: Proxy.PrActasCustodia) => {
          this.custodia = resultado;
        });
    }
  }

  public ActualizarRenuncia(dato: iRenuncia): void {
    if (dato != undefined) {

    }
  }

  /**
   * Indica si la persona que se hará cargo de la custodia es el delegado de campo
   */
  public CustodiaElDelegado(): void {
    this.esDelegadoCampo = true;
    this.primerFormularioValidado = true;

    // Establece los valores que tendrá la custodia, según los datos del delegado de campo
    if (this.participantes.TieneDelegado(true) && this.participantes.Delegado(true) != null) {
      let persona: Proxy.PrPersonaAlineable = this.licencias.AlineablePorIdentificador(this.participantes.Delegado(true).identificador);

      if (persona != undefined) {
        this.custodia.dni = persona.identificador;
        this.custodia.nombre = persona.nombre;
        this.custodia.apellidos = persona.apellido1 + ' ' + persona.apellido2;
        this.custodia.cargo = 'Delegado de campo';
        this.custodia.idClub = this.designacion.idLocal;
      }
    }
  }

  /**
   * Elimina la firma, tanto del canvas como de la designación
   */
  public EliminarFirma(): void {
    this.signatureComponent.signaturePad.clear();
    this.firma = "";
  }

  public FirmaInicializada($event: boolean): void {
    if (this.custodia != undefined) {
      this.firma = this.custodia.firma;
    }
    this.signatureComponent.signaturePad.fromDataURL(this.firma);
  }

  public GuardarFirma(): void {
    this.firma = this.signatureComponent.signaturePad.toDataURL("image/png");
    // Se comprueba que existe una firma
    if (this.firma.trim().length == 0) {
      this.Mensaje("No se ha detectado ninguna firma. No se puede guardar.", 6000);
    }
    else {
      this.custodia.firma = this.firma;
      this.custodia.entregada = true;

      this.custodia.Guardar(true)
        .then((resultado: Proxy.PrActasCustodia) => {
          this.custodia = resultado;
          this.Siguiente();
        });
    }
  }

  /**
   * Guarda las incidencias de la custodia asociada con la custodia, guardando al mismo tiempo la custodia y accediendo a la siguiente pantalla
   * @param form Datos del formulario asociado
   */
  public GuardarIncidencias(form: NgForm): void {
    if (form.valid) {
      this.custodia.sinIncidencias = false;
      this.custodia.entregada = true;

      this.custodia.Guardar(true)
        .then((resultado: Proxy.PrActasCustodia) => {
          this.custodia = resultado;
          this.Siguiente();
        });
    }
  }

  public RenunciaActualizada(valor: boolean): void {
    if (valor) {

      if (this.custodia.renuncia) {
        let action: ActionSheet = this.actionSheetCtrl.create({
          title: 'Renunciar a la custodia',
          subTitle: 'Renuncio al derecho que me asiste según el artículo xxx del Reglamento General Deportivo de la Federación Canaria de Fútbol, a que la Tablet sea custodiada por el delegado de campo o cualquier otra persona autorizada por el club local, razón por la que asumo toda la responsabilidad a los efectos de abono de los desperfectos y/o reparaciones acreditadas, o del importe total, también acreditado, del aparato en caso de extravío, robo o hurto.',
          buttons: [
            {
              text: 'Confirmar',
              handler: () => {
                this.custodia.Guardar(false)
                  .then((resultado: Proxy.PrActasCustodia) => {
                    this.Siguiente();
                  });
              }
            },
            {
              text: 'Cancelar',
              role: 'cancel'
            }
          ]
        });
        action.present();
      }
    }
    else {
      this.custodia.recogida = false;
      this.custodia.renuncia = false;
      this.custodia.aceptaResponsabilidad = undefined;
    }
  }

  public Siguiente(): void {

    let action: ActionSheet = this.actionSheetCtrl.create({
      title: 'Finalizar alineaciones',
      subTitle: 'Indique la acción a realizar',
      buttons: [
        {
          text: 'Salir',
          handler: () => {
            // Se debe marcar las alineaciones como terminadas y se sale a la validación de la aplicación
            this.designacion.OtrosDatos.alineacionesTerminadas = true;
            this.designacion.OtrosDatos.Guardar();
            this.Persistentes.SetDesignacion(this.designacion);

            this.Persistentes.SetArbitro(null);
            this.navCtrl.setRoot(LoginPage);
            return this.navCtrl.first();
          }
        },
        {
          text: 'Seguir con el resultado',
          handler: () => {
            // Se debe marcar las alineaciones como terminadas y se sale a la validación de la aplicación
            this.designacion.OtrosDatos.alineacionesTerminadas = true;
            this.designacion.OtrosDatos.Guardar();
            this.Persistentes.SetDesignacion(this.designacion);

            this.navCtrl.push(ResultadoPage);
          }
        },
        {
          text: 'Cancelar',
          role: 'cancel'
        }
      ]
    });
    action.present();
  }

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/custodia/custodia.ts